import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import LoadingScreen from '@/components/feature/LoadingScreen';

export default function AdminRoute() {
  const { profile, profileLoading } = useAuth();

  if (profileLoading) return <LoadingScreen />;
  if (profile?.role !== 'admin') return <Navigate to="/" replace />;

  return <Outlet />;
}